export default __webpack_public_path__ + "static/peace_type_label-b8a9a9f8ef90d3aa33ab651e522547e4.svg";